/**
 * JSON utility functions
 */

/**
 * Always returns a JSON string, even in case of invalid object
 * @param {any} obj object/variable/array
 * @returns {string} JSON string
 */
export function stringJson(obj: any): string {
    if (obj && typeof obj === 'string' && obj !== null) {
        return obj;
    } else {
        return JSON.stringify(obj);
    }
}

/**
 * Always returns a JSON object, even in case of invalid string
 * @param {string} str Text containing JSON
 * @param {boolean} allowStrings Allow plain strings to be returned
 * @returns {any} Object
 */
export function parseJson(str: any, allowStrings = false): any {
    if (str && typeof str === 'object' && str !== null) {
        return str;
    } else {
        try {
            if (allowStrings && ['{', '['].indexOf(str.charAt(0)) === -1) {
                return str;
            } else {
                const o = JSON.parse(str);
                if (o && typeof o === 'object' && o !== null) {
                    return o;
                } else if (o && typeof o === 'string') {
                    return parseJson(o);
                }
            }
        } catch (e) {
            const position = e.message.match(/position\s(\d+)/);
            console.log(
                'Cannot parse JSON from string: '
                    + (str
                        && str
                            .toString()
                            .substr(position && position[1] ? position[1] - 20 : 0, 100))
            );
        }
        return {};
    }
}
